import React, { useEffect, useState } from "react";
import {
  getDecryptedAccessToken,
  getDecryptedData,
  getDecryptedUserType,
} from "../../../Utils/LoginUserDetails.js/LoginUserSavedDetails";
import ApiServices from "../../../Utils/ApiServices/ApiServices";
import { Card, CardContent, Typography, Box, Button } from "@mui/material";
import { ErrorOutline, InsertDriveFile, Event } from "@mui/icons-material";
import UpdateLabReports from "./UpdateLabReports";
import { useNavigate } from "react-router-dom";

const PatientLabReports = ({ patientData }) => {
  const [alllabReports, setAllLabReports] = useState([]);
  const [labReports, setLabReports] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openDialog, setOpenDialog] = useState(false);
  const navigate= useNavigate()

  
  const LoginUserDetails = getDecryptedData();
  const LoginUserType = getDecryptedUserType();
  const accessToken = getDecryptedAccessToken();
  const pid =
    LoginUserType === "Patient" ? LoginUserDetails?.pid : patientData?.pid;
    const navigatePatientLabReports =()=>{
      LoginUserType === "Patient"?
      navigate("/patient/lab-reports"):
      navigate(`/provider/patient/lab-reports/${pid}`)
    }

 

  useEffect(() => {
    if (!pid) return;

    const apiUrl =
      LoginUserType === "Patient"
        ? `/apis/default/portal/patient/${pid}/document`
        : `/apis/default/api/patient/${pid}/document`;

    ApiServices.getwitParams(apiUrl,
      { path: "lab_report" },
      { Authorization: `Bearer ${accessToken}` }
    )
      .then((response) => {
        if (response.data?.length) {
          setAllLabReports(response.data)
          // Sort reports by docdate (newest first) and take the latest three
          const sortedReports = response.data
            .sort((a, b) => new Date(b.docdate) - new Date(a.docdate))
            .slice(0, 3);
          setLabReports(sortedReports);
        } else {
          setLabReports([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching lab reports:", error);
        setLabReports([]);
      })
      .finally(() => setLoading(false));
  }, [pid, LoginUserType, accessToken]);

  return (
    <Box>
      <Typography variant="h5" fontWeight="bold" sx={{ color: "#028391" }}>
        Lab Reports
      </Typography>
      <Card
        sx={{
          height: "100%",
          p: 2,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          border: "2px solid #028391",
          borderRadius: "12px",
          minHeight:"230px"
        }}
      >
        <CardContent>
          {loading ? (
            <Typography variant="body2" sx={{ color: "gray", mt: 1 }}>
              Loading lab reports...
            </Typography>
          ) : labReports.length > 0 ? (
            labReports.map((report, index) => (
              <Box
                key={index}
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  mt: 1,
                  p: 1,
                  borderRadius: "8px",
                  backgroundColor: "#f5f5f5",
                }}
              >
                {/* File Name */}
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <InsertDriveFile sx={{ fontSize: 20, color: "#028391", mr: 1 }} />
                  <Typography variant="body2">{report.name || "Unknown Report"}</Typography>
                </Box>

                {/* Document Date */}
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <Event sx={{ fontSize: 20, color: "#028391", mr: 1 }} />
                  <Typography variant="body2">{report.docdate || "No Date"}</Typography>
                </Box>
              </Box>
            ))
          ) : (
            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", mt: 2 }}>
              <ErrorOutline sx={{ fontSize: 40, color: "gray" }} />
              <Typography variant="body2" sx={{ color: "gray", mt: 1 }}>
                No lab reports available.
              </Typography>
            </Box>
          )}

          {/* Show All & Upload New Button */}
          <Box display="flex" justifyContent="center" mt={2}>
            <Button
              sx={{
                mt: 1,
                color: "#028391",
                textTransform: "none",
                "&:hover": { backgroundColor: "#02839120" },
              }}
              // onClick={() => setOpenDialog(true)}
              onClick={navigatePatientLabReports}
            >
              Show All & Upload New
            </Button>
          </Box>
        </CardContent>
      </Card>

      {/* Upload Lab Report Dialog */}
      {/* <UpdateLabReports open={openDialog} handleClose={() => setOpenDialog(false)} alllabReports={alllabReports}/> */}
    </Box>
  );
};

export default PatientLabReports;
